
export default {
    name: "ReportSubscribed",

    emits: ['click'],

    computed: {
        penIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/pen-success-dark.svg') :
                require('@/assets/icons/pen-success-light.svg');
        },
    },
}
